// export const CUSSIGNLIST = '/cemapi/cusSignList.json' // 签约列表
export const PREPURINTTRICAL = 'cemapi/prePurIntTriCal.json' // 预购利息试算
export const PRODINFO = 'cemapi/prodInfo.json' // 产品信息查询
export const EBANKBALANCESELECT = 'cemapi/EbankBalanceSelect.json' // 查询余额
export const USERACCLIST = 'cemapi/userAccList.json' // 查询账户列表
export const BILLACCOUNTNO = 'cemapi/billAccountNo.json' // 查询银行卡号
export const MYPOSITIONINFO = 'cemapi/myPositionInfo.json' // 我的持仓
export const ACCONTINFOQUERY = 'cemapi/accontInfoQuery.json' // 我的持仓下面列表
export const PRODUCTDRAW = 'cemapi/productDraw.json' // 存款支取取 鐘滔滔
export const PRODUCTPAY = 'cemapi/productPay.json' // 存款购买 鐘滔滔
export const PRODWITHDRAW = 'cemapi/prodWithdraw.json' // 存款支取取 鐘jik
export const PRODBUY = 'cemapi/prodBuy.json' // 存款goumai 鐘jik
export const ACCTTRANDETAIL = 'cemapi/acctTranDetail.json' // 查询交易记录列表
export const CUSINFO = 'cemapi/cusInfo.json' // 获取客户信息
export const BUYTIMESTATE = 'cemapi/buyTimeState.json' // 获取时间
export const PRODACCTINFO = 'cemapi/prodAcctInfo.json' // 获取交易结果时间  产品lsit
export const PRODTERMINATEAGREE = 'cemapi/prodTerminateAgree.json' // 解约
export const SMARTDEPOSITDUALAUTH = 'cemapi/smartDepositDualAuth.json' // 密码双重认证
export const DUALAUTHENTICATION = 'cemapi/dualAuthentication.json' // 短信密码双重认证
export const PREPURINTRATE = 'cemapi/prePurIntRate.json' // 宣传页汇率
export const LOGINPRODLIST = 'cemapi/loginProdList.json' // 产品宣传语
export const CUSSOURSE = 'cemapi/cusSource.json' // 客户验证
export const SENDSDSMS = 'cemapi/sendSDSms.json' // 发短信
